module.exports = __webpack_public_path__ + "static/media/Filter_Icon.9162896a.svg";